import AppError from '../libraries/AppError';
import Validator from '../libraries/Validator';
import getLuxonImpl from '../plugins/commonLibraries/timezone/timeboxImpl';
const complexCustomerInformationValidation = (order, isAdmin) => {
    if (isAdmin) {
        const notEmpty = (data) => {
            const emptyValues = ['', null, undefined];
            return !emptyValues.includes(data);
        };
        const customerDetailsValidationRules = {
            hasAtLeastOne: ['atLeastOneRequired'],
            email: [
                {
                    name: 'email',
                    condition: notEmpty,
                },
            ],
            phone: [
                {
                    name: 'phone',
                    condition: notEmpty,
                },
            ],
        };
        const validatorInputData = {
            hasAtLeastOne: {
                email: order.customerDetails.email,
                name: order.customerDetails.name,
                phone: order.customerDetails.telephone,
            },
            email: order.customerDetails.email,
            phone: order.customerDetails.telephone,
        };
        const validationResult = Validator.validateInputs(validatorInputData, customerDetailsValidationRules);
        if (Array.isArray(validationResult['hasAtLeastOne']) && validationResult['hasAtLeastOne'].length > 0) {
            throw AppError.OrderCustomerDataUndefinedError();
        }
        if (Array.isArray(validationResult['email']) && validationResult['email'].length > 0) {
            throw AppError.OrderCustomerEmailUndefinedError();
        }
        if (Array.isArray(validationResult['telephone']) && validationResult['telephone'].length > 0) {
            throw AppError.OrderCustomerTelUndefinedError();
        }
    }
    else {
        const customerDetailsValidationRules = {
            name: ['required'],
            email: ['required', 'email'],
            telephone: ['required', 'phone'],
        };
        const customerValidation = Validator.validateInputs({
            name: order.customerDetails.name,
            email: order.customerDetails.email,
            telephone: order.customerDetails.telephone,
        }, customerDetailsValidationRules);
        if (Array.isArray(customerValidation['name']) && customerValidation['name'].length > 0) {
            throw AppError.OrderCustomerNameUndefinedError();
        }
        if (Array.isArray(customerValidation['email']) && customerValidation['email'].length > 0) {
            throw AppError.OrderCustomerEmailUndefinedError();
        }
        if (Array.isArray(customerValidation['telephone']) && customerValidation['telephone'].length > 0) {
            throw AppError.OrderCustomerTelUndefinedError();
        }
    }
};
const TenantSpecificOrderValidation = function ({ order, isAdmin = false, }) {
    return Object.freeze({
        tid2: [
            () => {
                complexCustomerInformationValidation(order, isAdmin);
            },
        ],
        tid3: [
            () => {
                complexCustomerInformationValidation(order, isAdmin);
            },
        ],
        tid5: [
            () => {
                complexCustomerInformationValidation(order, isAdmin);
            },
        ],
        tid6: [
            () => {
                const TimeBoxImpl = getLuxonImpl();
                const format = TimeBoxImpl.Formats.YYYY_MM_DD;
                const currentDate = TimeBoxImpl.timebox.now().format(format).exec();
                if (currentDate !== order.pickupDate) {
                    throw AppError.OrderPickupTimeInvalidError('Pickup day of the order must be same day as ordering day').addData({
                        currentDate,
                        pickupDate: order.pickupDate,
                    });
                }
                const customerDetailsValidationRules = {
                    email: ['required', 'email'],
                };
                const customerValidation = Validator.validateInputs({
                    email: order.customerDetails.email,
                }, customerDetailsValidationRules);
                if (Array.isArray(customerValidation['email']) && customerValidation['email'].length > 0) {
                    throw AppError.OrderCustomerEmailUndefinedError();
                }
            },
        ],
    });
};
export default TenantSpecificOrderValidation;
